export default __webpack_public_path__ + "static/media/x.a15cc8d6.svg";